interface ConnectingScreenProps {
  roomId: string;
  isConnecting: boolean;
  isConnected: boolean;
  playerId: 1 | 2 | null;
  isSpectator: boolean;
  spectatorId: number | null;
  error: string | null;
  onBack: () => void;
}

export function ConnectingScreen({
  roomId,
  isConnecting,
  isConnected,
  playerId,
  isSpectator,
  spectatorId,
  error,
  onBack,
}: ConnectingScreenProps) {
  const getStatusMessage = () => {
    if (isConnecting) return 'Connecting to server...';
    if (isConnected && playerId === null && !isSpectator) return 'Determining role...';
    if (isConnected && playerId === 1) return 'You are host (Player 1). Waiting for second player...';
    if (isConnected && playerId === 2) return 'You are Player 2. Syncing game...';
    if (isConnected && isSpectator) return `You are spectator #${spectatorId}. Loading game state...`;
    return '';
  };

  return (
    <div className="connecting-screen">
      <h2>Connecting...</h2>
      <p>Room: {roomId}</p>
      <p>{getStatusMessage()}</p>
      {error && (
        <div className="error-message">
          <p>{error}</p>
        </div>
      )}
      <button
        className="action-btn secondary"
        onClick={onBack}
        style={{ marginTop: '2rem' }}
      >
        Back to Menu
      </button>
    </div>
  );
}
